import { defineMigrations } from '@tldraw/tldraw'

export const Versions = {
  AddFillProp: 1,
  DeleteFillColor: 2,
  AddIsEditableProp: 3,
  AddIsAutoUpdatableProp: 4,
} as const

export const frameShapeMigrations = defineMigrations({
  currentVersion: Versions.AddIsAutoUpdatableProp,
  migrators: {
    [Versions.AddFillProp]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            fill: {
              type: 'solidColor',
              color: shape.props.fillColor,
              opacity: 1,
            },
          },
        }
      },
      down: (shape) => {
        const { fill, ...props } = shape.props
        return {
          ...shape,
          props: {
            ...props,
            fillColor: fill.type === 'solidColor' ? fill.color : props.fillColor,
          },
        }
      },
    },
    [Versions.DeleteFillColor]: {
      up: (shape) => {
        const { fillColor: _, ...props } = shape.props
        return { ...shape, props }
      },
      down: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            fillColor: '#ffffff',
          },
        }
      },
    },
    [Versions.AddIsEditableProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isEditable: true } }
      },
      down: (shape) => {
        const { isEditable: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddIsAutoUpdatableProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isAutoUpdatable: true } }
      },
      down: (shape) => {
        const { isAutoUpdatable: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
  },
})
